module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "top__status"
  }, [_vm._v(_vm._s(_vm.status))]), _c('p', {
    staticClass: "top__title"
  }, [_vm._v("Привязка к "), (_vm.teamTitle) ? _c('span', [_vm._v(_vm._s(_vm.teamTitle))]) : _c('span', [_vm._v("не определена")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e745c04","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/programcard/components/top/MentoringTopCard.vue
// module id = c6ac5903f3f31e4db220
// module chunks = 89